import { createSlice } from "@reduxjs/toolkit";

const initalPerformanceState = {
  performance: {},
  companyPerformanace: [],
  performanceAnalytics: {},
  companyPerformanaceLoading: false,
  loading: false,
};

const performance = createSlice({
  name: "performance",
  initialState: initalPerformanceState,
  reducers: {
    getIndividualUserPerformanceSaga(state) {
      state.loading = true;
    },
    getUserTeamPerformanceSaga(state) {
      state.loading = true;
    },
    getPerformance(state, action) {
      state.performance = action.payload.data;
      state.loading = false;
    },
    getPerformanceFail(state) {
      state.loading = false;
    },
    clearPerformanceState(state) {
      state.performance = [];
    },
    getCompanyAdminPerformanceSaga(state) {
      state.loading = true;
    },
    getCompanyAdminPerformance(state, action) {
      state.performance = action.payload.data;
      state.loading = false;
      state.errorMessage = "";
    },
    getManagerPerformanceSaga(state) {
      state.loading = true;
    },
    getManagerPerformance(state, action) {
      state.performance = action.payload.data;
      state.loading = false;
      state.errorMessage = "";
    },

    getPerformanceRequest(state) {
      state.loading = true;
    },
    getPerformanceSuccess(state, action) {
      state.performance = action.payload.data;
      state.loading = false;
    },
    getPerformanceFailed(state) {
      state.loading = false;
    },
  },
});
export const performanceAction = performance.actions;
export default performance.reducer;
